import { STYLED_VARIABLES } from 'constants/styledVariables'

import React, { useEffect } from 'react'

import styled from 'styled-components'
import { MobileToolbarMenuToggle } from '@cloudike/web_ui_components'
import { useAppDispatch } from "store"
import { appActions } from 'store/app'

import { getMobileRightMenuStatusSelector } from '../selectors'

type Props = Omit<React.ComponentProps<typeof MobileToolbarMenuToggle>, 'onClick' | 'visible'> & {
    onClick?: (event: any) => void
}

const ConnectedMobileToolbarMenuToggle: React.FC<Props> = (
  {
    className = '',
    iconName,
    onClick,
    onChange,
    type
  }
) => {
  const dispatch = useAppDispatch()

  const handleClick = (event) => {
    if (onClick) {
      onClick(event)

      return
    }

    dispatch(appActions.toggleRightMenuOnMobile(true))
  }

  useEffect(() => {
    dispatch(appActions.setIsMobileMenuVisible(true))
    return () => {
      dispatch(appActions.setIsMobileMenuVisible(false))
    }
  }, [])

  const isRightSidebarActiveOnMobile = getMobileRightMenuStatusSelector()

  return (
    <StyledMobileToolbarMenuToggle
      visible={!isRightSidebarActiveOnMobile}
      onClick={handleClick}
      onChange={onChange}
      className={className}
      iconName={iconName}
      type={type}
    />
  )
}

const StyledMobileToolbarMenuToggle = styled(MobileToolbarMenuToggle)`

  svg {
    color: var(--background-primary)
  }

  &&& {
    transition: all 0.3s linear;

    @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.TABLET_10}) {
      display: none;
    }
  }
`

export { ConnectedMobileToolbarMenuToggle as MobileToolbarMenuToggle }
